import React, { useEffect, useState } from 'react';
import logo from '../images/logo.webp';
import { BsInfoCircle } from 'react-icons/bs';
import { IoCart } from 'react-icons/io5';
import { MdAccountCircle } from 'react-icons/md';
import { RxHamburgerMenu } from 'react-icons/rx';
import { IoClose } from 'react-icons/io5';
import { FaSortDown } from 'react-icons/fa6';
import { signOut } from '../../Redux/features/auth/authSlice';
import { Link, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { reset as resetOrder } from '../../Redux/features/order/orderSlice';
import { reset as resetStock } from '../../Redux/features/Stock/stockSlice';

const Navbar = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const dispatch = useDispatch();
	const { cartData } = useSelector((state) => state.auth);

	const [totalItems, setTotalItems] = useState(0);

	useEffect(() => {
		// Ensure cartData is defined before accessing its length
		if (cartData && Array.isArray(cartData)) {
			setTotalItems(cartData.length);
		} else {
			setTotalItems(0); // Set to 0 or any fallback value if cartData is undefined or not an array
		}
	}, [cartData]);

	const toggleMenu = () => {
		setIsMenuOpen((prevState) => !prevState);
	};

	const toggleDropdown = () => {
		setIsDropdownOpen((prevState) => !prevState);
	};
	const handleLogout = () => {
		dispatch(signOut());
		dispatch(resetOrder());
		dispatch(resetStock());
		navigate('/');
	};

	return (
		<>
			<div className='flex px-4 pt-4 h-16 w-full justify-between items-center sticky bg-white z-10'>
				<div className=' flex justify-start items-center '>
					<div className='md:hidden text-2xl max-[440px]:text-lg'>
						<button onClick={toggleMenu}>
							<RxHamburgerMenu />
						</button>
					</div>
					{/* Logo Section */}
					<div className='pl-5  max-[440px]:block'>
						<Link to='/dashboard'>
							<img
								src={logo}
								alt='Logo'
								className='w-16 object-cover aspect-auto max-[440px]:w-10'
							/>
						</Link>
					</div>
				</div>
				{/* Navbar Links */}
				<div className='hidden md:flex'>
					<ul className='flex flex-row gap-10 font-semibold'>
						{[
							{ name: 'Home', link: '/dashboard' },
							{ name: 'Order History', link: '/order-history' },
							// { name: 'Manual Order', link: '/manualorder' },
						].map((item) => (
							<li
								key={item.name}
								className={`cursor-pointer ${location.pathname === item.link ? 'text-red-500' : ''}`}>
								<Link to={item.link}>{item.name}</Link>
							</li>
						))}
					</ul>
				</div>

				{/* Right Icons Section */}
				<div className='flex flex-row justify-center items-center gap-10 md:pr-10 pr-5 max-[440px]:gap-5'>
					<ul className='flex flex-row gap-8 max-[440px]:gap-4 items-center md:text-3xl text-[25px] max-[440px]:text-xl'>
						<li>
							<Link to='/info'>
								<BsInfoCircle />
							</Link>
						</li>
						<li className='relative'>
							<Link to='/shoppingcart'>
								<IoCart />
								<span className='absolute sm:-top-1 -top-1.5 sm:-right-1 -right-1.5 bg-red-500 text-white rounded-full md:w-[18px] md:h-[18px] w-4 h-4 max-[400px]:h-3 max-[400px]:w-3  flex items-center justify-center text-[10px]'>
									{totalItems}
								</span>
							</Link>
						</li>
						<li onClick={toggleDropdown} className='relative cursor-pointer'>
							<MdAccountCircle />
							{isDropdownOpen && (
								<FaSortDown className='absolute sm:left-7 left-5 text-sm text-red-500 top-1' />
							)}
							{isDropdownOpen && (
								<ul className='absolute -right-6 mt-2 bg-white shadow-xl rounded w-[150px]'>
									<Link to='/changepassword'>
										<p className='block w-full text-left p-2 text-sm hover:text-red-500 font-medium'>
											Change Password
										</p>
									</Link>
									<button
										className='block w-full text-left p-2 text-sm hover:text-red-500 font-medium'
										onClick={handleLogout}>
										Logout
									</button>
								</ul>
							)}
						</li>
					</ul>
				</div>
			</div>

			{/* Sliding Menu */}
			<div
				className={`fixed top-0 left-0 h-full bg-white shadow-md transition-transform transform ${
					isMenuOpen ? 'translate-x-0' : '-translate-x-full'
				} md:hidden`}
				style={{ width: '80%', zIndex: 1000 }}>
				<div className='flex justify-between items-center p-4'>
					<Link
						to='/dashboard'
						onClick={() => {
							setIsMenuOpen(false);
						}}>
						<img src={logo} alt='' className='w-16 mb-2 hidden min-[400px]:block' />
					</Link>

					<button onClick={toggleMenu} className='text-2xl'>
						<IoClose />
					</button>
				</div>
				<ul className='flex flex-col p-4'>
					{[
						{ name: 'Home', link: '/dashboard' },
						{ name: 'Order History', link: '/order-history' },
						// { name: 'Manual Order', link: '/manualorder' },
					].map((item) => (
						<li
							className={`cursor-pointer mb-2 ${
								location.pathname === item.link ? 'text-red-500' : ''
							}`}
							key={item.name}>
							<Link
								to={item.link}
								onClick={() => {
									setIsMenuOpen(false);
								}}>
								{item.name}
							</Link>
						</li>
					))}
				</ul>
			</div>
		</>
	);
};

export default Navbar;
